import gql from 'graphql-tag'

const statsPubblicitaPieCharts = gql`
  query statsPubblicitaPieCharts($mese: Int, $anno: Int!, $tipologiaFiltroRisultati: TipologiaFiltroRisultati, $nazione: String) {
    statsPubblicitaPieCharts(mese: $mese, anno: $anno, tipologiaFiltroRisultati: $tipologiaFiltroRisultati, nazione: $nazione) {
      costi {
        tipoCampagna
        valore
      }
      contatti {
        tipoCampagna
        valore
      }
      appuntamenti {
        tipoCampagna
        valore
      }
    }
  }
`

export default statsPubblicitaPieCharts



// WEBPACK FOOTER //
// ./src/graphql/queries/statsPubblicitaPieCharts.js